import { render, staticRenderFns } from "./AutoMcqCards.vue?vue&type=template&id=e99dcbde&scoped=true"
import script from "./AutoMcqCards.vue?vue&type=script&lang=js"
export * from "./AutoMcqCards.vue?vue&type=script&lang=js"
import style0 from "./AutoMcqCards.vue?vue&type=style&index=0&id=e99dcbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99dcbde",
  null
  
)

export default component.exports